import type { SVGProps } from 'react';
import * as React from 'react';

const DocumentMagnifyingGlassIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/document-magnifying-glass">
      <g id="Icon">
        <path
          d="M9.59997 12C9.59997 11.0059 10.4059 10.2 11.4 10.2C12.3941 10.2 13.2 11.0059 13.2 12C13.2 12.4973 12.9995 12.9461 12.6728 13.2728C12.346 13.5995 11.8973 13.8 11.4 13.8C10.4059 13.8 9.59997 12.9941 9.59997 12Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.39998 1.6001C4.40586 1.6001 3.59998 2.40589 3.59998 3.4V20.6001C3.59998 21.5942 4.40586 22.4001 5.39998 22.4001H18.6C19.5941 22.4001 20.4 21.5942 20.4 20.6001V8.35C20.4 7.87261 20.2103 7.40757 19.8728 7.07L14.9272 2.13C14.5896 1.79243 14.1318 1.6001 13.6544 1.6001H5.39998ZM11.4 8.4C9.41175 8.4 7.79997 10.0118 7.79997 12C7.79997 13.9882 9.41175 15.6 11.4 15.6C12.0672 15.6 12.6927 15.4179 13.2286 15.1014L14.6636 16.5364C15.015 16.8879 15.5849 16.8879 15.9364 16.5364C16.2878 16.1849 16.2878 15.6151 15.9364 15.2636L14.5014 13.8286C14.8179 13.2927 15 12.6672 15 12C15 10.0118 13.3882 8.4 11.4 8.4Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);
export default DocumentMagnifyingGlassIcon;
